import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';
import { PAGINATION_SIZE_LIST } from 'utils/consts/pagination';

export const fetchHourlyByFilters = async body => {
	const requestBody = {
		pagination: {
			page: body.page,
			size: body.size || PAGINATION_SIZE_LIST[0],
			order: [],
		},
		filters: body.filters,
	};

	const response = await api.post('/horaHora/view', requestBody);
	return response.data;
};

export const useGetHourlyWithFilters = (variables: any) => {
	return useQuery(
		['hourly-list', variables],
		() => {
			const requestBody = {
				page: variables.page,
				size: variables.size,
				filters: variables.filters,
			};

			return fetchHourlyByFilters(requestBody);
		},

		{
			refetchOnWindowFocus: false,
			retry: false,
		}
	);
};
